import Collapsible, { CollapsibleHeader, CollapsibleHeaderCallout, CollapsibleHeading } from './Collapsible';

export default Collapsible;
export { Collapsible, CollapsibleHeader, CollapsibleHeading, CollapsibleHeaderCallout };
